export const ASK_USER_QUESTION_TOOL_NAME = 'ask_user_question';
export const ASK_USER_QUESTIONS_TOOL_NAME = 'ask_user_questions';
// The tool schema marks `possibleResponses` as required, but models don't
// always comply and historical tool calls may omit it entirely. Coerce each
// item to safe defaults so renderers can rely on `possibleResponses` always
// being an array (open-ended questions simply have an empty list).
export function normalizeQuestionItem(item) {
  var _item$allowMultipleSe;
  return {
    question: item.question,
    possibleResponses: Array.isArray(item.possibleResponses) ? item.possibleResponses : [],
    allowMultipleSelections: (_item$allowMultipleSe = item.allowMultipleSelections) !== null && _item$allowMultipleSe !== void 0 ? _item$allowMultipleSe : false
  };
}
export function normalizeQuestions(input) {
  if ('questions' in input) {
    return input.questions.map(normalizeQuestionItem);
  }
  return [normalizeQuestionItem(input)];
}
const QUESTION_ITEM_SCHEMA = {
  type: 'object',
  additionalProperties: false,
  properties: {
    question: {
      type: 'string',
      description: 'The question to ask the user.'
    },
    possibleResponses: {
      type: 'array',
      items: {
        type: 'string'
      },
      description: 'A list of predefined response options. Can be empty if only free-form text input is desired.'
    },
    allowMultipleSelections: {
      type: 'boolean',
      description: 'When true, the user can select multiple options (checkboxes). When false, only one option can be selected (radio buttons).'
    }
  },
  required: ['question', 'possibleResponses', 'allowMultipleSelections']
};
export const ASK_USER_QUESTION_SPEC = {
  name: ASK_USER_QUESTION_TOOL_NAME,
  description: 'Presents a question to the user with optional predefined response choices. Use this when you need explicit user input to proceed.',
  inputSchema: JSON.stringify(QUESTION_ITEM_SCHEMA)
};
export const ASK_USER_QUESTIONS_SPEC = {
  name: ASK_USER_QUESTIONS_TOOL_NAME,
  description: 'Presents multiple questions to the user with optional predefined response choices. Use this when you need answers to several questions before proceeding.',
  inputSchema: JSON.stringify({
    type: 'object',
    additionalProperties: false,
    properties: {
      questions: {
        type: 'array',
        items: QUESTION_ITEM_SCHEMA,
        description: 'An array of questions to present to the user.'
      }
    },
    required: ['questions']
  })
};
export const ASK_USER_QUESTION_TOOL = {
  name: ASK_USER_QUESTION_TOOL_NAME,
  description: ASK_USER_QUESTION_SPEC.description,
  inputSchema: QUESTION_ITEM_SCHEMA
};
export const ASK_USER_QUESTIONS_TOOL = {
  name: ASK_USER_QUESTIONS_TOOL_NAME,
  description: ASK_USER_QUESTIONS_SPEC.description,
  inputSchema: {
    type: 'object',
    additionalProperties: false,
    properties: {
      questions: {
        type: 'array',
        items: QUESTION_ITEM_SCHEMA,
        description: 'An array of questions to present to the user.'
      }
    },
    required: ['questions']
  }
};
export function serializeSingleResponse(response) {
  return JSON.stringify(response);
}
export function serializeMultiResponse(responses) {
  return JSON.stringify({
    questions: responses
  });
}
export function parseQuestionResponses(output) {
  try {
    const parsed = JSON.parse(output);
    if (Array.isArray(parsed.questions)) {
      return parsed.questions;
    }
    if (Array.isArray(parsed.selectedOptions)) {
      return [parsed];
    }
    return undefined;
  } catch (_unused) {
    return undefined;
  }
}
export function getPendingQuestion(activeTools) {
  for (const tool of activeTools) {
    if (tool.status === 'complete' || tool.status === 'error') continue;
    if (tool.toolName === ASK_USER_QUESTION_TOOL_NAME) {
      return {
        toolUseId: tool.toolUseId,
        questions: [normalizeQuestionItem(tool.input)]
      };
    }
    if (tool.toolName === ASK_USER_QUESTIONS_TOOL_NAME) {
      const input = tool.input;
      return {
        toolUseId: tool.toolUseId,
        questions: normalizeQuestions(input)
      };
    }
  }
  return null;
}